import { ReactNode } from 'react'

import { useSkatConnection } from '@features/vatDeclarations/contexts/skatConnectionContext'

import { SkatConnectionView } from '../SkatConnectionView'
import { SkatDisconnectionView } from '../SkatDisconnectionView'

interface SkatModuleProps {
  children: ReactNode
}

export const SkatModule = ({ children }: SkatModuleProps) => {
  const { showSkatConnectionView, showSkatDisconnectionView } = useSkatConnection()

  if (showSkatConnectionView) {
    return <SkatConnectionView />
  }

  if (showSkatDisconnectionView) {
    return <SkatDisconnectionView />
  }

  return <>{children}</>
}
